import { apiClient } from '@/services/client/ApiClient.js';
import naja from 'naja';

export default {
  getAll() {
    return apiClient.get('/threads', { useCache: true });
  },
  getAllAttachedPins() {
    return naja.makeRequest('GET', '?do=allAttachedLayers');
  },
  getAttachedPinsByLayer(layerId) {
    //return naja.makeRequest('GET', '?layerId=' + layerId + '&do=attachedLayer')
    return apiClient.get('/threads/attached-pins-by-layer/' + layerId);
  },
  getAllPinTypes() {
    return apiClient.get('/threads/pin-types/', { useCache: true });
  },
  getPinTypeById(pinTypeId) {
    return apiClient.get('/threads/pin-type-by-id/' + pinTypeId);
  }
};
